import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zM12 7v10H2V7h10zm-1.5 8l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
}), 'ArtTrackSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArtTrackSharp.js
// module id = 2131
// module chunks = 2